import { AdminInvoice } from '../model/adminInvoice';
export class AdminInvoiceBuilder {
    static buildAdminInvoice(data) {
        const adminInvoice = new AdminInvoice();
        adminInvoice.id = data.id;
        adminInvoice.id_bill_amend = data.id_bill_amend;
        adminInvoice.number_invoice = data.number_invoice;
        adminInvoice.number_ticket = data.number_ticket;
        adminInvoice.bill_number = data.bill_number ? data.bill_number : null;
        adminInvoice.date = data.date;
        adminInvoice.date_conversion = data.date_conversion;
        adminInvoice.id_agency = data.id_agency;
        adminInvoice.id_client = data.id_client;
        adminInvoice.id_invoice_profile = data.id_invoice_profile;
        adminInvoice.id_paymethod = data.id_paymethod;
        adminInvoice.type = data.type;
        adminInvoice.payment_status = data.payment_status;
        adminInvoice.version = data.version;
        adminInvoice.vat_rate_standard = data.vat_rate_standard;
        adminInvoice.vat_rate_trans = data.vat_rate_trans;
        adminInvoice.base_standard = data.base_standard;
        adminInvoice.base_trans = data.base_trans;
        adminInvoice.vat_standard = data.vat_standard;
        adminInvoice.vat_trans = data.vat_trans;
        adminInvoice.pvp_total = data.pvp_total;
        adminInvoice.name_prefix = data.name_prefix;
        adminInvoice.name = data.name;
        adminInvoice.nif = data.nif;
        adminInvoice.address = data.address;
        adminInvoice.state = data.state;
        adminInvoice.city = data.city;
        adminInvoice.zip = data.zip;
        adminInvoice.email = data.email;
        adminInvoice.lang = data.lang;
        adminInvoice.notes = data.notes;
        adminInvoice.id_lot = data.id_lot;
        adminInvoice.id_company = data.id_company;
        adminInvoice.cash = data.cash;
        adminInvoice.id_sale = data.id_sale;
        adminInvoice.id_costcenter = data.id_costcenter;
        adminInvoice.receipt = data.receipt;
        adminInvoice.id_a3_link = data.id_a3_link;
        adminInvoice.a3_errors = data.a3_errors;
        return adminInvoice;
    }
}
//# sourceMappingURL=adminInvoice-builder.js.map